// libs
import { useSelector } from 'react-redux'
import { IRootState } from 'src/reducers/interface'

export const useSelectActiveFilter = () => useSelector(({ filters }: IRootState) => filters.activeFilter)

export const useSelectDateFilter = () => useSelector(({ filters }: IRootState) => filters.dateFilterRange)
